<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="infoData" :model='infoData' label-position="right" :label-width="200"
            @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="投入品名称" prop="title">
              <Input disabled="disabled" class="perW30" v-model="infoData.title"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="重量(g)" prop="weight">
              <Input disabled="disabled" class="perW30" v-model="infoData.weight"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="规格单位" prop="spec">
              <Input disabled="disabled" class="perW30" v-model="infoData.spec"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="有效期" prop="date">
              <Input disabled="disabled" class="perW30" v-model="infoData.date"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="安全间隔期(天)" prop="safety_days">
              <Input disabled="disabled" class="perW30" v-model="infoData.safety_days"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="浓度" prop="concentration">
              <Input disabled="disabled" class="perW30" v-model="infoData.concentration"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="登记证号" prop="licence">
              <Input disabled="disabled" class="perW30" v-model="infoData.licence"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="生产厂家" prop="production">
              <Input disabled="disabled" class="perW30" v-model="infoData.production"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="生产批号" prop="batch_number">
              <Input disabled="disabled" class="perW30" v-model="infoData.batch_number"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="批准文号" prop="approval">
              <Input disabled="disabled" class="perW30" v-model="infoData.approval"></Input>
            </FormItem>
          </Col>

        </Row>
      </Form>
    </card>

  </div>
</template>
<script>
import {plantThingsStockInfoApi} from '@/api/plant/plantThingsStock'

export default {
  name: 'plantThingsStockInfo',
  data() {
    return {
      infoData: {
        id: 0,
        title: '',
        weight: '',
        spec: '',
        date: '',
        safety_days: '',
        concentration: '',
        licence: '',
        production: '',
        batch_number: '',
        approval: '',
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {

    // 编辑加载数据
    loadFormData(id) {
      plantThingsStockInfoApi(id).then(res => {
        //数据赋值
        this.infoData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
